import testRechargeApi from "@/request/testRecharge";
import url from "postcss-url";

const urls = {
  // 充值相关
  unifiedOrderUrl: "/order/unifiedOrder",
  getProductUrls:"/order/loadProductConfigs",
  getServerUrls:"/server/v1/loadServerList",
  getQueryRoles:"/order/queryRoles",


  // getResultByCode: "/backend/api/wechatPay/getResultByCode",
  // getWeChatPayServer: "/backend/api/publicsrc/getWeChatPayServer",
};

const testRecharApi = {
    // 充值相关
    unifiedOrder: (params) => {
      console.log(params)
      return testRechargeApi({ 
        url: urls.unifiedOrderUrl,
         method: "post", 
         data:params});
    },
    getServerUrls: () => {
      return testRechargeApi({ 
        url: urls.getServerUrls, 
        method: "post", 
       
      });
    },
    getProductUrls: () => {
      return testRechargeApi({ 
        url: urls.getProductUrls, 
        method: "post", 
       
      });
    },
    getQueryRoles: (params) => {
      return testRechargeApi({ 
        url: urls.getQueryRoles, 
        method: "post", 
        data:params
      });
    },
  
    // getResultByCode: (params) => {
    //   return request({ url: urls.getResultByCode, method: "get", params: { ...params } });
    // },
    // getWeChatPayServer: () => {
    //   return request({ url: urls.getWeChatPayServer, method: "get" });
    // },
};

export default testRecharApi;
